import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {MiCuidado} from '../historialCuidados/MiCuidado';
import graficaMonitor from './graficaMonitorCuidados.png';
import {CuidadoMonitorCuidado} from './CuidadoMonitorCuidado';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {TarjetaPresupuestos_cliente} from './TarjetaPresupuestos_cliente';
import {BotonesSuperiorPresupuestos} from '../Presupuestos/BotonesSuperiorPresupuestos';
import {MenuLateralAB} from '../menuLateralAA/MenuLateralAB';
import axios from 'axios';
import {animateScroll as scroll} from 'react-scroll';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import { ButtonGroup, Modal as M } from 'react-bootstrap';
import CustomTooltip from '../../hooks/ToolTip';
export const ContentBodyMonitorCuidados = (props) => {
	const {MenuLateralAux, chageMenuLateralAux} = props;
	/* A function that allows you to go back to the previous page. */
	const navigate = useNavigate();
	const goToBack = () => {
		navigate(-1);
	};

	const [FiltroNombre, setFiltroNombre] = useState('');
	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

	/* Setting the state of the TipoNotificaciones variable to an array of strings. */
	const [TipoNotificaciones, setTipoNotificaciones] = useState([
		'buttonNotificacionesActive',
		'buttonNotificaciones',
		'buttonNotificaciones',
		'buttonNotificaciones',
	]);
	const [NumerServicios, setNumberServicios] = useState(0, 0, 0, 0);
	const [PageNumber, setPageNumber] = useState(1);
	const [CountPages, setCountPages] = useState(1);
	const [SiguientePagina, setSiguientePagina] = useState(false);
	/* Setting the state of the NumPresupuestos variable to an array of numbers. */
	const [NumPresupuestos, setNumPresupuestos] = useState([0, 0, 0, 0]);
	const [ListaPacientes, setListaPacientes] = useState([]);
	/** */
	const [ServicioId, setServicioId] = useState();
	/* Setting the state of the ListaPresupuesto variable to an array of objects. */
	const [ListaPresupuesto, setListaPresupuesto] = useState([]);

	const [ServicioPacientes, setServicioPacientes] = useState([]);

	/**
	 * It sends a request to the server and waits for a response.
	 */
	/* Setting the state of the modalCancelarServicio variable to false. */
	const [modalCancelarServicio, setmodalCancelarServicio] = useState(false);
	/* It closes the modal window. */

	/* Setting the state of the modalActivar variable to false. */
	const [modalConfirmar, setmodalConfirmar] = useState(false);
	/* Setting the state of the modalActivar variable to false. */
	const [modalActivar, setmodalActivar] = useState(false);
	/* Setting the state of the EstadoActivacion variable to 0. */

	const calcularNumeroPaginas = (numer) => {
		let basico = parseInt(numer / 5);
		let demas = numer % 5;
		if (demas != 0 || basico == 0) {
			basico++;
		}
		setCountPages(basico);
	};
	/* A function that is called when the user clicks on one of 
    the buttons on the top of the page. */
	const cambioNotificaciones = (num) => {
		setPageNumber(1);
		let listaAxu = [
			'buttonNotificaciones',
			'buttonNotificaciones',
			'buttonNotificaciones',
			'buttonNotificaciones',
		];
		listaAxu[num] = 'buttonNotificacionesActive';
		let listaAxu2 = [];
		let estado0 = 0;
		let estado1 = 0;
		let estado2 = 0;
		let estado3 = 0;
		/* A function that is called when the user clicks 
        on one of the buttons on the top of the page. */
		ServicioPacientes.map((presupuesto) => {
			setServicioPacientes([]);
			if (parseInt(presupuesto.estado) === parseInt(num)) {
				listaAxu2.push(presupuesto);
			}
			if (parseInt(presupuesto.estado) === 0) {
				estado0++;
			} else if (parseInt(presupuesto.estado) === 1) {
				estado1++;
			} else if (parseInt(presupuesto.estado) === 2) {
				estado2++;
			} else if (parseInt(presupuesto.estado) === 3 || parseInt(presupuesto.estado) === 4) {
				estado3++;
			}
		});

		const tipes = [
			'get_Presupuestos_Hoy_Cliente',
			'get_Presupuestos_Pendientes_Cliente',
			'get_Presupuestos_Por_Confirmar_Cliente',
			'get_Presupuestos_All_Cliente',
		];
		getPresupuestos(tipes[num]);

		setTipoNotificaciones(listaAxu);
		setListaPresupuesto(listaAxu2);
		setNumPresupuestos([estado0, estado1, estado2, estado3]);
	};

	const getPresupuestos = (tipe, paginator) => {
		scroll.scrollToTop();
		let url = '';
		if (paginator !== null && paginator !== undefined) {
			url = window.ipdirection + tipe + '?page=' + paginator;
			setPageNumber(paginator);
		} else {
			url = window.ipdirection + tipe;
			setPageNumber(1);
		}
		axios({
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			method: 'get',
			url: url,
		})
			.then((response) => {
				if (response.data.next !== null) {
					setSiguientePagina(true);
				} else {
					setSiguientePagina(false);
				}
				calcularNumeroPaginas(response.data.count);
				calcularNotificaciones();
				getFotoPaciente(response.data.results);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getServiciosPacientes = () => {
		let lista = [];
		axios({
			url: window.ipdirection + 'servicioEmpresaPacienteCliente/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			method: 'get',
		})
			.then((response) => {
				getFotoPaciente(response.data);
				cambioNotificaciones(0);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const getFotoPaciente = (lista) => {
		let listaServicios = [];
		setServicioPacientes([]);
		lista.map((servicio) => {
			axios({
				method: 'get',
				url:
					window.ipdirection +
					'imagenPerfilPaciente/?paciente_id=' +
					servicio.paciente_id.id,
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
			})
				.then((response) => {
					axios({
						method: 'get',
						url:
							window.ipdirection +
							'imagenPerfilPaciente/' +
							response.data[0].id +
							'/',
						headers: {
							Authorization: 'Bearer ' + Usuario.access,
						},
						responseType: 'blob',
					})
						.then((response2) => {
							listaServicios.push({
								...servicio,
								paciente_id: {
									...servicio.paciente_id,
									fotoPaciente: URL.createObjectURL(response2.data),
								},
							});
							setServicioPacientes([...listaServicios]);
						})
						.catch((error) => {
							listaServicios.push({
								...servicio,
								paciente_id: {
									...servicio.paciente_id,
									fotoPaciente:
										'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
								},
							});
							setServicioPacientes([...listaServicios]);
							console.clear();
							console.log('error 2');
							console.log(error.response);
						});
				})
				.catch((error) => {
					listaServicios.push({
						...servicio,
						paciente_id: {
							...servicio.paciente_id,
							fotoPaciente:
								'https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.omgtb.com%2Fwp-content%2Fuploads%2F2021%2F04%2F620_NC4xNjE-768x768.jpg&f=1&nofb=1&ipt=6e70641a1d064ed7a25e8f5428a004d5f8b720a9ae21a2028f48a538530174b2&ipo=images',
						},
					});
					setServicioPacientes([...listaServicios]);
					console.clear();
					console.log('error 2');
					console.log(error.response);
				});
		});
	};
	const paginaAnterior = () => {
		if (PageNumber > 1) {
			const tipes = [
				'get_Presupuestos_Hoy_Cliente',
				'get_Presupuestos_Pendientes_Cliente',
				'get_Presupuestos_Por_Confirmar_Cliente',
				'get_Presupuestos_All_Cliente',
			];
			let contador = 0;
			TipoNotificaciones.map((notificacion) => {
				if (notificacion === 'buttonNotificacionesActive') {
					getPresupuestos(tipes[contador], PageNumber - 1);
				}
				contador++;
			});
		}
	};
	const paginaSiguiente = () => {
		if (SiguientePagina) {
			const tipes = [
				'get_Presupuestos_Hoy_Cliente',
				'get_Presupuestos_Pendientes_Cliente',
				'get_Presupuestos_Por_Confirmar_Cliente',
				'get_Presupuestos_All_Cliente',
			];
			let contador = 0;
			TipoNotificaciones.map((notificacion) => {
				if (notificacion === 'buttonNotificacionesActive') {
					getPresupuestos(tipes[contador], PageNumber + 1);
				}
				contador++;
			});
		}
	};
	const calcularNotificaciones = () => {
		axios({
			method: 'get',
			url: window.ipdirection + 'numero_notificaciones_cliente/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				setNumberServicios(response.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	/* Calling the function `cambioNotificaciones(0)` when the component is mounted. */
	useEffect(() => {
		scroll.scrollToTop();
		cambioNotificaciones(1);
		calcularNotificaciones();
	}, []);

	const cancelarServicio = (id) => {
		setServicioId(id);
		setmodalCancelarServicio(true);
	};
	const rechazarServicio = (id) => {
		let Id;
		if (id === undefined) {
			Id = ServicioId;
		} else {
			Id = id;
		}
		axios({
			method: 'delete',
			url: window.ipdirection + 'servicioEmpresaPacienteCliente/' + Id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		})
			.then((response) => {
				cambioNotificaciones(getEstado());
			})
			.catch((error) => {
				console.log(error);
			});
		setmodalCancelarServicio(false);
	};
	const eliminarServicio = (id) => {
		let Id;
		if (id === undefined) {
			Id = ServicioId;
		} else {
			Id = id;
		}
		axios({
			method: 'put',
			url: window.ipdirection + 'servicioEmpresaPacienteCliente/' + Id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			// poner en 5
			data: {estado: 4},
		})
			.then((response) => {
				//getServiciosPacientes();
				cambioNotificaciones(getEstado())
			})
			.catch((error) => {
				console.log(error);
			});
		setmodalCancelarServicio(false);
	};
	const confirmar = (id) => {
		setServicioId(id);
		setmodalConfirmar(true);
	};
	const confirmarServicio = () => {
		axios({
			method: 'put',
			url: window.ipdirection + 'servicioEmpresaPacienteEmpresa/' + ServicioId + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: {estado: 3},
		})
			.then((response) => {
				getServiciosPacientes();
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const activarPresupuestos = (id) => {
		setServicioId(id);
		setmodalActivar(true);
	};
	const enviarServicio = () => {
		axios({
			method: 'put',
			url: window.ipdirection + 'servicioEmpresaPacienteEmpresa/' + ServicioId + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
			data: {estado: 1},
		})
			.then((response) => {
				getServiciosPacientes();
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getEstado = () => {
		if (TipoNotificaciones[0] === 'buttonNotificacionesActive') {
			return 0;
		} else if (TipoNotificaciones[1] === 'buttonNotificacionesActive') {
			return 1;
		} else if (TipoNotificaciones[2] === 'buttonNotificacionesActive') {
			return 2;
		} else if (TipoNotificaciones[3] === 'buttonNotificacionesActive') {
			return 3;
		}
	};

	const getEstadoAux = () => {
		if (TipoNotificaciones[3] === 'buttonNotificacionesActive') {
			return 4;
		}
	};

	return (
		<>
			<MenuLateralAB
				seleccionado={12}
				MenuLateralAux={MenuLateralAux}
				chageMenuLateralAux={chageMenuLateralAux}
			/>
			<div className='ContentBodyMonitorCuidados'>
				<div className='head-monitorCuidados'>
					<div className='titleMisPacientes'>
						<div className='tilte centrador'>
							<svg
								xmlns='http://www.w3.org/2000/svg'
								width='40'
								height='40'
								fill='currentColor'
								className='bi bi-heart-pulse'
								viewBox='0 0 16 16'
							>
								<path d='m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053.918 3.995.78 5.323 1.508 7H.43c-2.128-5.697 4.165-8.83 7.394-5.857.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17c3.23-2.974 9.522.159 7.394 5.856h-1.078c.728-1.677.59-3.005.108-3.947C13.486.878 10.4.28 8.717 2.01L8 2.748ZM2.212 10h1.315C4.593 11.183 6.05 12.458 8 13.795c1.949-1.337 3.407-2.612 4.473-3.795h1.315c-1.265 1.566-3.14 3.25-5.788 5-2.648-1.75-4.523-3.434-5.788-5Z' />
								<path d='M10.464 3.314a.5.5 0 0 0-.945.049L7.921 8.956 6.464 5.314a.5.5 0 0 0-.88-.091L3.732 8H.5a.5.5 0 0 0 0 1H4a.5.5 0 0 0 .416-.223l1.473-2.209 1.647 4.118a.5.5 0 0 0 .945-.049l1.598-5.593 1.457 3.642A.5.5 0 0 0 12 9h3.5a.5.5 0 0 0 0-1h-3.162l-1.874-4.686Z' />
							</svg>
							<b>Mis citas</b>
							<CustomTooltip textContent={"Aquí puedes ver como va el estado de tus citas."}/>
						</div>
					</div>
					<div className='separador'></div>
					<div className='menuClientes BotonesSuperiorPresupuestos'>
						{/* <div
							className={TipoNotificaciones[0]}
							onClick={() => cambioNotificaciones(0)}
						>
							<div className='centrador'>{'Hoy (' + NumerServicios.hoy + ')'}</div>
						</div> */}
						<div
							className={TipoNotificaciones[1]}
							onClick={() => cambioNotificaciones(1)}
						>
							<div className='centrador'>
								{'Próximas (' + NumerServicios.pendientes + ')'}
							</div>
						</div>
						<div
							className={TipoNotificaciones[2]}
							onClick={() => cambioNotificaciones(2)}
						>
							<div className='centrador'>
								{'Pendientes de confirmar(' + NumerServicios.porConfirmar + ')'}
							</div>
						</div>
						<div
							className={TipoNotificaciones[3]}
							onClick={() => cambioNotificaciones(3)}
						>
							<div className='centrador'>
								{'Pasadas (' + NumerServicios.completados + ')'}
							</div>
						</div>
					</div>
				</div>

				<div className='tarjetasPresupuestos-cliente'>
					<div className='listaTarjetas'>
						{ServicioPacientes.map((tarjetaPaciente) => (
							<TarjetaPresupuestos_cliente
								key={tarjetaPaciente.id}
								id={tarjetaPaciente.id}
								imagenPaciente={tarjetaPaciente.paciente_id.fotoPaciente}
								nombrePaciente={
									tarjetaPaciente.paciente_id.nombrePaciente +
									' ' +
									tarjetaPaciente.paciente_id.apellidosPaciente
								}
								telefono={tarjetaPaciente.paciente_id.telefonoPaciente}
								direccion={tarjetaPaciente.paciente_id.direccionPaciente}
								localidad={tarjetaPaciente.paciente_id.localidad}
								precio={tarjetaPaciente.servicio_Empresa_id.precioMin}
								servicio={tarjetaPaciente.servicio_Empresa_id.servicio_id.nombre}
								horasMin={tarjetaPaciente.servicio_Empresa_id.horasMin}
								fechaPaciente={tarjetaPaciente.paciente_id.fechaNacimiento}
								nombrePrestador={
									tarjetaPaciente.servicio_Empresa_id.prestadorServicios_id
										.nombreEmpresa
								}
								idPresupuesto={tarjetaPaciente.id}
								fecha={
									tarjetaPaciente.fechaServicio +
									' a las ' +
									tarjetaPaciente.hora_inicio
								}
								activarPresupuestos={activarPresupuestos}
								setmodalCancelarServicio={setmodalCancelarServicio}
								TipoNotificaciones={TipoNotificaciones}
								confirmar={confirmar}
								cancelarServicio={cancelarServicio}
								rechazarServicio={rechazarServicio}
								eliminarServicio={eliminarServicio}
								prestadorServicio={tarjetaPaciente.servicio_Empresa_id.prestadorServicios_id}
							/>
						))}
						{ServicioPacientes.length === 0 && (
						<div className="centrador pt-5 text-center">
							<p className="tam">
							Aún no tienes ninguna cita agendada.
							</p>

							<p className="tam">
								¿Te gustaría algún servicio de cuidados o asistencia?
							</p>
							<button
							onClick={() => navigate('/busqueda?q=&lugar=0&categoria=0')}
							className="btn login-boton tam2 mt-5"
							>
							Buscar servicios
							</button>
						</div>
						)}
					</div>
					<div className='paginador-Presupuestos'>
						{PageNumber > 1 ? (
							<div
								className='button boton-paginador boton-paginador-anterior'
								onClick={paginaAnterior}
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='16'
									height='16'
									fill='currentColor'
									class='bi bi-caret-left-fill'
									viewBox='0 0 16 16'
								>
									<path d='m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z' />
								</svg>
							</div>
						) : (
							<div className='boton-paginador-vacio' />
						)}
						<div className='centrador'>
							<div className='numero-paginador'>
								{PageNumber} de {CountPages}
							</div>
						</div>
						{SiguientePagina ? (
							<div
								className='button boton-paginador boton-paginador-siguiente'
								onClick={paginaSiguiente}
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='16'
									height='16'
									fill='currentColor'
									class='bi bi-caret-right-fill'
									viewBox='0 0 16 16'
								>
									<path d='m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z' />
								</svg>
							</div>
						) : (
							<div className='boton-paginador-vacio' />
						)}
					</div>
				</div>
			</div>
			<M
				centered={true}
				show={modalCancelarServicio}
			>
				<M.Header>
					<div className='titulo-modal'>Confirmación de rechazo de servicio</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-modal'>¿Desea cancelar el servicio?</div>
				</M.Body>
				<M.Footer>
					<div className='centrador-Botones-botones-perfil-empresa'>
						<ButtonGroup
							className='btn outline-boton'
							onClick={() => {
								setmodalCancelarServicio(false);
							}}
						>
							<b>Cancelar</b>
						</ButtonGroup>
						<button
							className='btn btn-outline-danger'
							onClick={() => {
								if (getEstado() === 2) {
									console.log(getEstado());
									rechazarServicio();
								} else {
									console.log(getEstado());
									eliminarServicio();
								}
							}}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>
		</>
	);
};
